import { useEffect, useCallback, useState } from 'react';

export const useScrollPassed = (top: number) => {
  const [passed, setPassed] = useState(false);

  const onScroll = useCallback(() => {
    if (window.pageYOffset >= top) {
      setPassed(true);
    } else {
      setPassed(false);
    }
  }, [top]);

  useEffect(() => {
    window.onscroll = onScroll;

    return () => {
      window.onscroll = null;
    };
  }, [onScroll]);

  return passed;
};
